"use strict";
var $ = require("../internals/export");
var fails = require("../internals/fails");
var expm1 = require("../internals/math-expm1");
var abs = Math.abs;
var exp = Math.exp;
var E = Math.E;
var FORCED = fails(function() {
  return Math.sinh(-2e-17) !== -2e-17;
});
$({ target: "Math", stat: true, forced: FORCED }, {
  sinh: function sinh(x) {
    var n = +x;
    return abs(n) < 1 ? (expm1(n) - expm1(-n)) / 2 : (exp(n - 1) - exp(-n - 1)) * (E / 2);
  }
});
